const constants = require('../constants');
const slickSlider = require('../components/slider');
const utils = require('../utils');

const cartCarousel = () => {
    $(window).on('load', () => {
        // eslint-disable-next-line consistent-return
        const checkElement = (selector, fn) => {
            if ($(selector).length) {
                fn();
                return;
            }
            setTimeout(() => {
                checkElement(selector, fn);
            }, 200);
        };

        const getSlotTitle = () => {
            const featuredCarousel = $('.featured-product-carousel');

            if (featuredCarousel.length) {
                const slotTitle = $('.featured-product-carousel > .featured-carousel-container').find('.callout-slot').attr('value');
                featuredCarousel.find('span.h3').text(slotTitle);
            }
        };

        const runSlick = (element) => {
            const { prev, next } = utils.getSliderLabels();
            slickSlider.methods.useCustomizableSlick(
                element,
                true,
                `<button type="button" class="icon-left-arrow-line next no-btn" aria-label="${prev}"></button>`,
                `<button type="button" class="icon-right-arrow-line prev no-btn" aria-label="${next}"></button>`,
                4,
                {
                    dots: false,
                    arrows: true,
                    infinite: false,
                    adaptiveHeight: true,
                    responsive: [
                        {
                            breakpoint: constants.viewport_bootstrap.md,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 2,
                                arrows: true,
                                dots: false,
                            },
                        },
                        {
                            breakpoint: constants.viewport_bootstrap.lg,
                            settings: {
                                slidesToShow: 3,
                                slidesToScroll: 3,
                                arrows: true,
                                dots: false,
                            },
                        },
                    ],
                },
            );

            checkElement('.featured-product-carousel span.h3', getSlotTitle);
        };

        const slickConfig = () => {
            checkElement('#Cart-Show .page .product-carousel .product', runSlick.bind(null, '#Cart-Show .page .product-carousel'));
        };

        slickConfig();
    });
};

module.exports = () => {
    if ($('#Cart-Show').length) {
        cartCarousel();
    }
};
